import React from 'react';
import { useTranslation } from 'react-i18next';
import { EvaluationSteps } from '~valuation/enums';
import { ValuationTypeEnum } from '~/constants/enums/valuationEnums';
import getStepsCount from '~valuation/utils/getStepsCount';

const ProgressBar = ({
  activeStep,
  valuationType,
}: {
  activeStep: number;
  valuationType: string | undefined;
}) => {
  const { t } = useTranslation('app');
  const isNotGoalStep = activeStep !== EvaluationSteps.GOAL;
  const stepNumber = activeStep + 1;
  const totalSteps =
    valuationType && isNotGoalStep
      ? getStepsCount(valuationType as ValuationTypeEnum)
      : 0;
  const stepPercentage =
    valuationType && isNotGoalStep
      ? Number(((stepNumber / totalSteps) * 100).toFixed(0))
      : 0;

  return (
    <div className="w-full flex flex-col gap-2x px-2x md:px-0">
      <div className="flex items-center justify-between text-xs text-gray-700">
        <p className="text-body_2 text-gray__dark_2">
          {`${t('finalStep')} ${stepNumber >= totalSteps ? (totalSteps === 0 ? 1 : totalSteps) : stepNumber}
        ${valuationType && isNotGoalStep ? `${t('from')} ${totalSteps}` : ''}
        `}
        </p>
        {valuationType && isNotGoalStep && (
          <p className="text-caption text-gray__dark_2">
            {stepPercentage >= 100 ? '100' : stepPercentage}%
          </p>
        )}
      </div>

      <div className="w-full h-3 rounded-full overflow-hidden bg-[#E8F2F9]">
        <div
          className="h-full bg-blue-600 rounded-full transition-all duration-300 bg-blue"
          style={{
            width: `${stepPercentage === 0 ? 9 : stepPercentage >= 100 ? 100 : stepPercentage}%`,
          }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
